import * as React from "react";
import { graphql, compose } from "react-apollo";
import Select from "react-select";

import gql from "graphql-tag";

import BODebounceInput from "app/components/BOComponents/BODebounceInput";

import TopBar from "./Ops.Merchants.MerchantsGeneralTopBar";
import AllMerchantsContainer from "app/components/AppComponents/Merchants/AllMerchantsContainer";
import { Grid } from "@material-ui/core";

type State = {
  search: string;
  tags: TagOption[];
  availableTags: string[];
  queryParameterTags: string[] | null;
  isLoading: boolean;
};

type TagOption = {
  label: string;
  value: string;
};

const tagsQuery = graphql(
  gql`
    query merchantTags {
      merchant_tags {
        name
      }
    }
  `,
  {
    name: "merchantTags"
  }
);

class List extends React.Component<any, State> {
  state = {
    search: "",
    tags: [],
    availableTags: [],
    queryParameterTags: null,
    isLoading: true
  };

  static getTagsFromQueryParameters(props: any) {
    const params = new URLSearchParams(props.location.search);
    const tagsParam = params.get("tags");
    return tagsParam ? tagsParam.split(",") : null;
  }

  static getDerivedStateFromProps(props: any, state: State) {
    const newAvailableTags = props.merchantTags.merchant_tags;
    const queryParameterTags = List.getTagsFromQueryParameters(props);

    if (newAvailableTags || queryParameterTags) {
      const derivedState: any = {};

      if (
        newAvailableTags &&
        JSON.stringify(newAvailableTags) !== JSON.stringify(state.availableTags)
      ) {
        derivedState.availableTags = newAvailableTags;
        derivedState.isLoading = false;
      }

      if (queryParameterTags && !state.queryParameterTags) {
        derivedState.queryParameterTags = queryParameterTags;
        derivedState.tags = queryParameterTags.map(tag => ({
          label: tag,
          value: tag
        }));
      }

      return derivedState;
    }

    // Return null to indicate no change to state.
    return null;
  }

  tagOptions() {
    return this.state.availableTags.map(tag => ({
      label: tag.name,
      value: tag.name
    }));
  }

  componentDidMount() {
    this.props.setHeader({
      title: "Ops > Merchants",
      description: "SnapScan merchants"
    });
  }

  render() {
    return (
      <React.Fragment>
        <TopBar />
        <section className="padded">
          <Grid container spacing={16} direction="row" justify="center">
            <Grid item xs={12} sm={12} md={4}>
              <BODebounceInput
                minLength={2}
                debounceTimeout={300}
                value={this.state.search}
                placeholder="Search Merchants"
                onChange={newValue => {
                  this.setState({ search: newValue });
                }}
              />
            </Grid>
            <Grid item xs={12} sm={12} md={8}>
              <Select
                isMulti="1"
                isClearable={false}
                isDisabled={this.state.isLoading}
                isLoading={this.state.isLoading}
                onChange={(tags: TagOption[]) => {
                  this.setState({ tags: tags || [] });
                }}
                options={this.tagOptions()}
                value={this.state.tags}
                placeholder="Tags"
              />
            </Grid>
          </Grid>
          <AllMerchantsContainer
            name={"ops.merchants.list"}
            search={this.state.search}
            tags={this.state.tags.map(tagOption => tagOption.value)}
          />
        </section>
      </React.Fragment>
    );
  }
}

export default compose<any>(tagsQuery)(List);
